"use client";
import React,{useState} from 'react'
import styles from "./Accordion.module.css"
import { FaPlus } from "react-icons/fa6";
import { GrSubtract } from "react-icons/gr";

export default function Accordion({ title, content }) {
    const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={styles.accordion}>
    <button className={styles.accordionHeader} onClick={() => setIsOpen(!isOpen)}>
      {title}
      <span className={`${styles.icon} ${isOpen ? styles.open : ""}`}>
        {isOpen ? <GrSubtract/> : <FaPlus/>}
      </span>
    </button>
    {isOpen && <div className={styles.accordionContent}>{content}</div>}
  </div>
  )
}
